import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import queryString from "query-string";

import "./AbsenceList.css"

import history from "../../../../history";
import { getAbsenceList, getHoursList } from "../../../../actions/absenceActions";

class AbsenceList extends React.Component {
    componentDidMount() {
        const queryParams = queryString.parse(history.location.search);
        const newQueryParams = Object.keys(queryParams).filter(key => ["year"].includes(key)).reduce((obj, key) => {
            obj[key] = queryParams[key];
            return obj;
        }, {});
        const newQueryString = queryString.stringify(newQueryParams)
        if (newQueryString !== queryString.stringify(queryParams)) history.push({ search: newQueryString });

        this.startType = "";
        this.lastFiltersParams = {};
        this.filtersParams = {};
        this.updateList();    
    }

    componentDidUpdate() {
        this.updateFilters();
        this.updateList();
    }

    updateList = () => {
        this.queryParams = queryString.parse(history.location.search);
        let curFilters = this.getFilters(this.queryParams);

        if (this.props.type !== this.startType || JSON.stringify(this.lastFiltersParams) !== JSON.stringify(curFilters)) {
            this.startType = this.props.type;
            this.lastFiltersParams = { ...curFilters };
            if (this.props.type === "absence") this.props.getAbsenceList(curFilters);
            else if (this.props.type === "hours") this.props.getHoursList(curFilters);
        }
    };

    getFilters = queryParams => {
        let filters = { ...this.filtersParams };
        if (queryParams.year !== filters.year)
            if (queryParams.year !== null && queryParams.year !== undefined) filters.year = queryParams.year; else delete filters.year;
        return filters;
    };

    updateFilters = () => {
        let filters = { ...this.filtersParams };
        if (this.props.year !== filters.year)
            if (this.props.year !== null && this.props.year !== undefined) filters.year = this.props.year; else delete filters.year
        if (JSON.stringify(this.filtersParams) !== JSON.stringify(filters)) {
            this.filtersParams = filters;
            history.push({ search: queryString.stringify(filters) });
        }
    };

    renderYearMenu = () => {
        const today = new Date();
        const currentYear = today.getFullYear();
        const year = this.props.year !== null ? this.props.year : currentYear;

        return (
            <div className={`ui two item menu`}>
                {year <= currentYear + 1 ? (
                    <Link to={`${history.location.pathname}?year=${year - 1}`} className="item">
                        <div className="content">Poprzedni rok</div>
                    </Link>
                ) : (
                    <div className="disabled item">
                        <div className="content">Poprzedni rok</div>
                    </div>
                )}
                {year < currentYear ? (
                    <Link to={`${history.location.pathname}?year=${year + 1}`} className="item">
                        <div className="content">Następny rok</div>
                    </Link>
                ) : (
                    <div className="disabled item">
                        <div className="content">Następny rok</div>
                    </div>
                )}
            </div>
        );
    };

    renderRows = list => list.map((pos, index) => this.renderRow(pos, index));

    renderRow = (row = null, index = null) => {
        return (
            <tr key={row ? index : "header"}>
                <td className={row ? "content" : "header"}>{row ? this.props.type === "absence" ? row.absenceName : row.dateFrom : this.props.type === "absence" ? "Przyczyna nieobecności" : "W dniu"}</td>
                <td className={row ? "content" : "header"}>{row ? this.props.type === "absence" ? row.dateFrom : row.timeFrom : this.props.type === "absence" ? "Od dnia" : "Od godziny"}</td>
                <td className={row ? "content" : "header"}>{row ? this.props.type === "absence" ? row.dateTo : row.timeTo : this.props.type === "absence" ? "Do dnia" : "Do godziny"}</td>
                {this.props.type === "absence" ? (
                    <td className={row ? "content" : "header"}>{row ? row.dayCount : "Ilość dni"}</td>
                ) : null}
            </tr>
        );
    };

    render() {
        return (
            <React.Fragment>
                <div className="absence-list-component ui container">
                    <div className="ui two item menu">
                        <Link to="/absence" className="active item">
                            <div className="content">Wykaz nieobecności</div>
                        </Link>
                        <Link to="/absence/limits" className="item">
                            <div className="content">Wymiar urlopu</div>
                        </Link>
                    </div>
                    <div className="ui two item menu">
                        <Link to="/absence" className={`${this.props.type === "absence" ? "active " : ""}item`}>
                            <div className="content">Nieobecności</div>
                        </Link>
                        <Link to="/absence/hours" className={`${this.props.type === "hours" ? "active " : ""}item`}>
                            <div className="content">Odebrane godziny</div>
                        </Link>
                    </div>
                    {this.renderYearMenu()}
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.type === "absence" ? (
                            <React.Fragment>
                                {this.props.report.absence.list.length ? (
                                    <React.Fragment>
                                        <div className="ui large header">
                                            <div className="content">Nieobecności w roku: {this.props.report.year}</div>
                                        </div>
                                        <table className="content">
                                            <tbody>
                                                {this.renderRow()}
                                                {this.renderRows(this.props.report.absence.list)}
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                ) : (
                                    <div className="ui large header">
                                        <div className="content">Brak nieobecności w roku: {this.props.report.year}</div>
                                    </div>
                                )}
                                <div className="ui divider" />
                                <div className="footer content">
                                    {this.props.report.absence.updatedOn ? (
                                        <p>Wykaz zaktualizoany dnia: <b>{this.props.report.absence.updatedOn}</b></p>
                                    ) : null}
                                </div>
                            </React.Fragment>
                        ) : (
                            Object.keys(this.props.report.hours).length ? (
                                <React.Fragment>
                                    <div className="ui large header">
                                        <div className="content">Odebrane godziny w roku: {this.props.report.year}</div>
                                    </div>
                                    <table className="content">
                                        <tbody>
                                            {this.renderRow()}
                                            {this.renderRows(this.props.report.hours)}
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            ) : (
                                <div className="ui large header">
                                    <div className="content">Brak odebranych godzin w roku: {this.props.report.year}</div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    report: state.absence.report,
    year: state.absence.report.year
});

export default connect(mapStateToProps, { getAbsenceList, getHoursList })(AbsenceList);